import React from "react";
import {
  Grid,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { PhotoUploaderStyles } from "./PhotoUploaderStyles";
import PhotosUploadUtil, { truncateFileName } from "./PhotosUploadUtil";
import CloseIcon from "@material-ui/icons/Close";
import "./photosstyle.css";
import {
  FILE_SIZE_ERROR,
  FILE_TYPE_ERROR,
  MAX_ALLOWED_PHOTO_SIZE_IN_MB,
} from "../constants/GlobalConstants";

export const BackDriver = (props: any) => {
  const classes = PhotoUploaderStyles();
  const [imgBDSPreview, setImgBDSPreview] = React.useState(undefined);
  const [imgBPSPreview, setImgBPSPreview] = React.useState(undefined);
  const [imgBDSPreviewName, setImgBDSPreviewName] = React.useState(undefined);
  const [imgBPSPreviewName, setImgBPSPreviewName] = React.useState(undefined);
  const [bdsError, setBDSError] = React.useState(undefined);
  const [bpsError, setBPSError] = React.useState(undefined);
  const [bdsErrorMessage, setBDSErrorMessage] = React.useState(FILE_SIZE_ERROR);
  const [bpsErrorMessage, setBPSErrorMessage] = React.useState(FILE_SIZE_ERROR);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const handleEvent = (e) => {
    console.log(e.target.id);
    if (e.target.files.length > 1) {
    } else {
      const selected = e.target.files[0];
      let selectedFile = e.target.files[0];
      const selectID = e.target.id;
      if (selectID === "drop_bds_bt") {
        setBDSError(false);
      } else if (selectID === "drop_bps_bt") {
        setBPSError(false);
      }
      console.log(selected.name);
      let selectedFileSize = selected.size / 1024 / 1024; // in MB
      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      let image = new Image();
      if (
        selected &&
        ALLOWED_TYPES.includes(selected.type) &&
        selectedFileSize <= MAX_ALLOWED_PHOTO_SIZE_IN_MB
      ) {
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        reader.onloadend = () => {
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            if (selectID === "drop_bds_bt") {
              setImgBDSPreview(reader.result);
              selectedFile.imageLabel = "Driver Side Back";
              selectedFile.additionalDescription = "Driver Side Back";
              selectedFile.imageDisplayFileName = selected.name;
              setImgBDSPreviewName(selected.name);
            } else if (selectID === "drop_bps_bt") {
              setImgBPSPreview(reader.result);
              selectedFile.imageLabel = "Passenger Side Back";
              selectedFile.additionalDescription = "Passenger Side Back";
              selectedFile.imageDisplayFileName = selected.name;
              setImgBPSPreviewName(selected.name);
            }
            //fileInfoArr.push(selectedFile);
            props.updatePhotoFile(selectedFile);
          };
        };

        reader.readAsDataURL(selected);
      } else if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
        console.log("Error: File size more than 10 MB");
        if (selectID === "drop_bds_bt") {
          setBDSError(true);
          setBDSErrorMessage(FILE_SIZE_ERROR);
        } else if (selectID === "drop_bps_bt") {
          setBPSError(true);
          setBPSErrorMessage(FILE_SIZE_ERROR);
        }
      } else {
        console.log("Error: File not supported");
        if (selectID === "drop_bds_bt") {
          setBDSError(true);
          setBDSErrorMessage(FILE_TYPE_ERROR);
        } else if (selectID === "drop_bps_bt") {
          setBPSError(true);
          setBPSErrorMessage(FILE_TYPE_ERROR);
        }
      }
    }
    //console.log("Number of files" + uploadPhotoList.length);
  };
  function dragOverHandler(ev) {
    console.log("File(s) in drop zone");
    ev.preventDefault();
  }
  function bdsDropHandler(ev) {
    ev.preventDefault();
    if (ev.dataTransfer.items[0].kind === "file") {
      let image = new Image();
      const selected = ev.dataTransfer.items[0].getAsFile();
      let selectedFile = ev.dataTransfer.items[0].getAsFile();
      setBDSError(false);
      let selectedFileSize = selected.size / 1024 / 1024; // in MB

      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      if (selected && ALLOWED_TYPES.includes(selected.type)) {
        console.log("Selected");
        if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
          setBDSError(true);
          setBDSErrorMessage(FILE_SIZE_ERROR);
          return;
        }

        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        reader.onloadend = () => {
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            setImgBDSPreview(reader.result);
            selectedFile.imageLabel = "Driver Side Back";
            selectedFile.additionalDescription = "Driver Side Back";
            selectedFile.imageDisplayFileName = selected.name;
            setImgBDSPreviewName(selected.name);
            props.updatePhotoFile(selectedFile);
          };
        };
        reader.readAsDataURL(selected);
      } else {
        setBDSError(true);
        setBDSErrorMessage(FILE_TYPE_ERROR);
      }
    }
  }
  // rps setting for drag
  function bpsDropHandler(ev) {
    ev.preventDefault();
    if (ev.dataTransfer.items[0].kind === "file") {
      let image = new Image();
      const selected = ev.dataTransfer.items[0].getAsFile();
      let selectedFile = ev.dataTransfer.items[0].getAsFile();
      setBPSError(false);
      let selectedFileSize = selected.size / 1024 / 1024; // in MB

      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      if (selected && ALLOWED_TYPES.includes(selected.type)) {
        console.log("Selected");
        if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
          setBPSError(true);
          setBPSErrorMessage(FILE_SIZE_ERROR);
          return;
        }
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        reader.onloadend = () => {
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            setImgBPSPreview(reader.result);
            selectedFile.imageLabel = "Passenger Side Back";
            selectedFile.additionalDescription = "Passenger Side Back";
            selectedFile.imageDisplayFileName = selected.name;
            setImgBPSPreviewName(selected.name);
            props.updatePhotoFile(selectedFile);
          };
        };
        reader.readAsDataURL(selected);
      } else {
        setBPSError(true);
        setBPSErrorMessage(FILE_TYPE_ERROR);
      }
    }
  }

  function deleteBDSFile() {
    setImgBDSPreview(null);
    props.deleteBDSFile();
  }
  function deleteBPSFile() {
    setImgBPSPreview(null);
    props.deleteBPSFile();
  }
  function deleteBDSErrorFile() {
    setBDSError(false);
  }
  function deleteBPSErrorFile() {
    setBPSError(false);
  }

  function onBpsFileSelectClick() {
    try {
      let elm = document.getElementById("drop_bps_bt");
      elm.click();
    } catch {}
  }

  function onBdsFileSelectClick() {
    try {
      let elm = document.getElementById("drop_bds_bt");
      elm.click();
    } catch {}
  }

  return (
    <Grid container spacing={2}>
      <Grid container item xs={12} md={6} className={classes.photoInfoDetails}>
        <Typography className={classes.photoInfoDetails}>
          Back Driver Side &nbsp;&nbsp;
        </Typography>
        <Grid
          item
          xs={12}
          className={classes.dropZone}
          id="drop_zone"
          onDrop={bdsDropHandler}
          onDragOver={dragOverHandler}
          onClick={onBdsFileSelectClick}
          data-testid={"drop_zone_back"}
        >
          {!bdsError ? (
            !imgBDSPreview ? (
              <Grid className={classes.container}>
                <Grid container alignItems="center">
                  <Grid item xs={3} sm={12}>
                    <input
                      type="file"
                      id="drop_bds_bt"
                      data-testid={"drop_bds_bt"}
                      className="fileUpload"
                      style={{ display: "none" }}
                      accept=".jpeg,.jpg"
                      onChange={handleEvent}
                    />

                    <span
                      className={classes.icon + " icon-car-driver-rear"}
                    ></span>
                  </Grid>
                  <Grid item xs={9} sm={12}>
                    <label className={classes.regularText}>
                      {"Drag & drop a file here or click to select a file"}
                    </label>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid style={{ textAlign: "center" }}>
                <Grid container>
                  <Grid item xs={2} md={5}>
                    <img
                      id="clickImg2"
                      src={imgBDSPreview}
                      className={
                        isMobile
                          ? classes.imagePreviewMobile
                          : classes.imagePreview
                      }
                      alt=""
                    />
                  </Grid>
                  <Grid item xs={8} md={5} className={classes.imagePrevName}>
                    <Typography className={classes.imageName}>
                      {truncateFileName(imgBDSPreviewName)}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} style={{ alignContent: "center" }}>
                    <Button
                      color="default"
                      data-testid={"delete_back"}
                      startIcon={<CloseIcon />}
                      onClick={() => deleteBDSFile()}
                      className={classes.rightButton}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )
          ) : (
            <Grid
              style={{
                textAlign: "center",
                paddingRight: "30px",
                paddingLeft: "30px",
              }}
            >
              <Grid container>
                <Grid container item xs={11} style={{ padding: "1rem" }}>
                  <Grid item xs={10} md={6} style={{ alignContent: "center" }}>
                    <span
                      className="icon-no-image"
                      style={{
                        fontSize: "45px",
                        color: "#8A0200",
                      }}
                    ></span>
                  </Grid>
                  <Grid item xs={10} md={6}>
                    <label className={classes.errorText}>
                      {bdsErrorMessage}
                      <br />
                      <br /> Please select another photo.
                    </label>
                  </Grid>
                </Grid>

                <Grid container item alignContent="center" xs={1}>
                  <Button
                    color="default"
                    startIcon={<CloseIcon />}
                    onClick={() => deleteBDSErrorFile()}
                    className={classes.rightButton}
                    data-testid={"delete_back_error"}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Grid container item xs={12} md={6} className={classes.photoInfoDetails}>
        <Typography className={classes.photoInfoDetails}>
          Back Passenger Side
        </Typography>
        <Grid
          item
          xs={12}
          className={classes.dropZone}
          id="drop_zone"
          data-testid={"drop_zone_front"}
          onDrop={bpsDropHandler}
          onDragOver={dragOverHandler}
          onClick={onBpsFileSelectClick}
        >
          {!bpsError ? (
            !imgBPSPreview ? (
              <Grid className={classes.container}>
                <Grid container alignItems="center">
                  <Grid item xs={3} sm={12}>
                    <input
                      type="file"
                      id="drop_bps_bt"
                      data-testid={"drop_bps_bt"}
                      className="fileUpload"
                      style={{ display: "none" }}
                      accept=".jpeg,.jpg"
                      onChange={handleEvent}
                    />

                    <span
                      className={classes.icon + " icon-car-passenger-rear"}
                    ></span>
                  </Grid>
                  <Grid item xs={9} sm={12}>
                    <label className={classes.regularText}>
                      {"Drag & drop a file here or click to select a file"}
                    </label>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid style={{ textAlign: "center" }}>
                <Grid container>
                  <Grid item xs={2} md={5}>
                    <img
                      id="clickImg2"
                      src={imgBPSPreview}
                      className={
                        isMobile
                          ? classes.imagePreviewMobile
                          : classes.imagePreview
                      }
                      alt=""
                    />
                  </Grid>
                  <Grid item xs={8} md={5} className={classes.imagePrevName}>
                    <Typography className={classes.imageName}>
                      {truncateFileName(imgBPSPreviewName)}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} style={{ alignContent: "center" }}>
                    <Button
                      color="default"
                      data-testid={"delete_front"}
                      startIcon={<CloseIcon />}
                      onClick={() => deleteBPSFile()}
                      className={classes.rightButton}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )
          ) : (
            <Grid
              style={{
                textAlign: "center",
                paddingRight: "30px",
                paddingLeft: "30px",
              }}
            >
              <Grid container>
                <Grid container item xs={11} style={{ padding: "1rem" }}>
                  <Grid item xs={10} md={6} style={{ alignContent: "center" }}>
                    <span
                      className="icon-no-image"
                      style={{
                        fontSize: "45px",
                        color: "#8A0200",
                      }}
                    ></span>
                  </Grid>
                  <Grid item xs={10} md={6}>
                    <label className={classes.errorText}>
                      {bpsErrorMessage}
                      <br />
                      <br /> Please select another photo.
                    </label>
                  </Grid>
                </Grid>

                <Grid container item alignContent="center" xs={1}>
                  <Button
                    color="default"
                    startIcon={<CloseIcon />}
                    onClick={() => deleteBPSErrorFile()}
                    className={classes.rightButton}
                    data-testid={"delete_front_error"}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
export default BackDriver;
